// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".type--B6EvO {\n  flex: 1;\n  padding-left: 1.5em;\n  background-color: transparent;\n  border: none;\n}", "",{"version":3,"sources":["webpack://./src/gui/Components/ChatBot/TextInput/Single/index.module.scss"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;AACd","sourcesContent":[".type {\n  flex: 1;\n  padding-left: 1.5em;\n  background-color: transparent;\n  border: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"type": "type--B6EvO"
};
export default ___CSS_LOADER_EXPORT___;
